import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Accordion, AccordionTab } from "primereact/accordion";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IDropdown } from "../../models/BaseModel";
import { JVDropdownInput } from "../../shared/JVDropdownInput";

export interface IFilter {
    contact?: IDropdown;
    contactId?: number;
    statusId?: number;
    sourceId?: number;
    countryId?: number;
    stateId?: number;
    cityId?: number;
    fromDate?: Date | null | string;
    toDate?: Date | null | string;
    createdBy?: number | null;
}

const schema = yup.object({});

interface Iprops {
    filter: IFilter,
    loading: boolean,
    header: any,
    toast: any,
    setFilter: (filter: IFilter) => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Filter = (props: Iprops) => {
    const [countries, setCountries] = useState<IDropdown[]>();
    const [states, setStates] = useState<IDropdown[]>();
    const [cities, setCities] = useState<IDropdown[]>();
    const [contacts, setContacts] = useState<IDropdown[]>();
    const [sources, setSources] = useState<IDropdown[]>();
    const [status, setStatus] = useState<IDropdown[]>();
    const [users, setUsers] = useState<IDropdown[]>();

    const { control, handleSubmit, reset, watch, setValue } = useForm<IFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filter,
        shouldFocusError: false
    });

    const countryId = watch("countryId");
    const stateId = watch("stateId");

    useEffect(() => {
        loadCountries();
        loadStatus();
        loadSources();
        loadUsers();
    }, []);

    useEffect(() => {
        if (countryId) {
            setValue("stateId", undefined);
            setValue("cityId", undefined);
            setStates([]);
            setCities([]);
            loadStates(countryId);
        }
    }, [countryId]);

    useEffect(() => {
        if (stateId) {
            setValue("cityId", undefined);
            setCities([]);
            loadCities(stateId);
        }
    }, [stateId]);

    const loadCountries = async () => {
        const response = await Fetch("country/dropdown", "GET", null, null, null);
        if (response) {
            const countryList = await response.json();
            setCountries([{ id: undefined, name: "--Select Country--" }, ...countryList]);
        }
    }

    const loadStatus = async () => {
        const response = await Fetch("status/dropdown", "GET", null, null, null);
        if (response) {
            const statusList = await response.json();
            setStatus([{ id: undefined, name: "--Select Status--" }, ...statusList]);
        }
    }


    const loadUsers = async () => {
        const response = await Fetch("user/dropdown", "GET", null, null, null);
        if (response) {
            const userList = await response.json();
            setUsers([{ id: undefined, name: "--Select--" }, ...userList]);
        }
    }

    const loadSources = async () => {
        const response = await Fetch("source/dropdown", "GET", null, null, null);
        if (response) {
            const sourceList = await response.json();
            setSources([{ id: undefined, name: "--Select Source--" }, ...sourceList]);
        }
    }

    const loadStates = async (countryId: number) => {
        const response = await Fetch(`state/dropdown/${countryId}`, "GET", null, null, null);
        if (response) {
            const stateList = await response.json();
            setStates([{ id: undefined, name: "--Select State--" }, ...stateList]);
        }
    }

    const loadCities = async (stateId: number) => {
        const response = await Fetch(`city/dropdown/${stateId}`, "GET", null, null, null);
        if (response) {
            const cityList = await response.json();
            setCities([{ id: undefined, name: "--Select City--" }, ...cityList]);
        }
    }

    const loadContacts = async (text: string | null) => {
        const query = text ? `text=${text}` : '';
        const response = await Fetch("contact/dropdown", "GET", null, query, null);
        if (response) {
            setContacts(await response.json());
        }
    }
    const completeMethodContacts = (event: { query: string }) => {
        loadContacts(event.query);
    }

    const searchToDB = async (body: IFilter) => { props.setFilter(body); }

    function onSubmit(data: IFilter) {
        if (data.contact) {
            data.contactId = data.contact.id;
        }
        data.fromDate = data.fromDate === "" || data.fromDate == null ? null : data.fromDate;

        data.toDate = data.toDate === "" || data.toDate == null ? null : data.toDate;
        if (data.fromDate && data.toDate) {
            const fromDate = new Date(data.fromDate);
            const toDate = new Date(data.toDate);

            if (toDate < fromDate) {
                props.toast.current?.show({
                    severity: "warn",
                    summary: "Validation",
                    detail: "To Date cannot be less than From Date.",
                    life: 4000,
                });
                return;
            }
        }
        searchToDB(data);
    }

    const Clear = () => {
        reset({
            fromDate: null,
            toDate: null,
            contact: undefined,
            contactId: undefined,
            statusId: undefined,
            sourceId: undefined,
            countryId: undefined,
            stateId: undefined,
            cityId: undefined,
            createdBy: undefined
        });

        setStates([]);
        setCities([]);
    };
    return (
        <Accordion>
            <AccordionTab header={props.header}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVDate
                        column={4}
                        label="From Date"
                        control={control}
                        name="fromDate"
                        maxDate={new Date()}
                        placeholder="Select From Date"
                    />
                    <JVDate
                        column={4}
                        label="To Date"
                        control={control}
                        name="toDate"
                        maxDate={new Date()}
                        placeholder="Select To Date"
                    />
                    <JVDropdownInput column={4} completeMethod={completeMethodContacts} label="Contact" control={control} name="contact" options={contacts} optionLabel="name" placeholder="Search Contact" />
                    <JVDropdown column={4} label="Status" control={control} options={status} optionLabel="name" optionValue="id" name="statusId" placeholder="Select Status" />
                    <JVDropdown column={4} label="Source" control={control} options={sources} optionLabel="name" optionValue="id" name="sourceId" placeholder="Select Source" />
                    <JVDropdown column={4} label="Country" control={control} options={countries} optionLabel="name" optionValue="id" name="countryId" placeholder="Select Country" />
                    <JVDropdown column={4} label="State" control={control} options={states} optionLabel="name" optionValue="id" name="stateId" placeholder="Select State" />
                    <JVDropdown column={4} label="City" control={control} options={cities} optionLabel="name" optionValue="id" name="cityId" placeholder="Select City" />
                    <JVDropdown
                        column={4}
                        label="Assigned By"
                        control={control}
                        options={users}
                        optionLabel="name"
                        optionValue="id"
                        name="createdBy"
                        placeholder="Select User"
                    />
                    <div className="col-12 md:col-3 gap-4 flex align-items-center justify-content-center mt-3">
                        <Button style={{ width: '100px', height: '34px' }} loading={props.loading} label="SEARCH" type="submit" className="p-button-rounded"></Button>
                        <Button style={{ width: '100px', height: '34px' }} label="CLEAR" onClick={Clear} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                    </div>
                </form>
            </AccordionTab>
        </Accordion>
    );
}
